import styled from 'styled-components'
import { styled as muiStyled } from '@mui/material/styles'

export const JoinSessionRelatedSelectorButtons = muiStyled('div')(
  ({ theme }) => `
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  align-items: center;
  @media (min-width: ${theme.breakpoints.values?.lg}px) {
    flex-direction: row;
  }
`,
)
